export default {
  path: '/',
  redirect: '/dashboard',
  name: 'Home',
};
